import React from 'react'
import {XLPrimaryButton, SmallLinkButton} from "@worthy-npm/clarity"
import I18n from "lib/i18n/i18n"
import WorthyApi from "lib/api/worthyApi"
import { browserHistory } from 'react-router'


const ConfirmCancellationModal = (props) => {

    const onButtonClick = (stopAnimation) => {
        WorthyApi.cancelAppointment(props.appointmentId)
            .then(() => {
                stopAnimation()
                props.logger('Call canceled')
                props.onCloseModal()
                browserHistory.push('/manage-call/call-canceled')
            })
            .catch(() => {
                stopAnimation()
            })
    }

    return (
        <div className={'confirm-cancel-modal'}>
            <p className={'text'}>{I18n.getString('manageCall::callDetails::confirmCancellation::text')}</p>
            <div className={'button'}>
                <XLPrimaryButton
                    text={I18n.getString('manageCall::callDetails::confirmCancellation::button')}
                    click={(stopAnimation) => { onButtonClick(stopAnimation) }}
                    overrideCSS={{'width': '100%'}} overrideWrapperCSS={{'width': '100%'}} />
            </div>
            <SmallLinkButton
                text={I18n.getString('manageCall::callDetails::confirmCancellation::link')}
                click={() => { props.onCloseModal() }} />
        </div>
    )
}

export default ConfirmCancellationModal
